export default __webpack_public_path__ + "media/images/lm-og-logo-ff4133ac92667d2d8de7ce58085a4481.png";